import { connect } from 'react-redux'
import Reports from '../../Reports'
import InternalReports from '../../InternalReports'
import { checkPermission } from '../../../utils/permissionValidation'
import { Pages } from '../../../utils/pages'

function ReportsSwitcher({ userPermissions, ...rest }) {
  const canSeeInternal = checkPermission(userPermissions, Pages.internalReports.permission)

  if (canSeeInternal) {
    return <InternalReports {...rest} />
  }
  return <Reports {...rest} />
}

function mapStateToProps({ userPermissions }) {
  return { userPermissions: userPermissions || {} }
}
export default connect(mapStateToProps)(ReportsSwitcher)
